import React, { Component } from "react";
import DOMPurify from "dompurify";

class CommunityDetails extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<div className="community-details-container d-flex p-4 justify-content-center flex-column flex-md-row">
					{this.props.data.community_description === null ||
					this.props.data.community_description === "" ? (
						<div className="d-flex flex-column align-items-center">
							<div className="d-flex community-image">
								{this.props.data.community_image_url && (
									<img
										src={this.props.data.community_image_url}
										alt={this.props.data.community_name}
										width="170"
										height="170"
									/>
								)}
								{!this.props.data.community_image_url && (
									<i className="fas fa-users" width={170} height={170} />
								)}
							</div>
							<div className="textual-info mt-3">
								<h1 className="community-name mb-3 text-center">
									{this.props.data.community_name}
								</h1>
							</div>
							<div className="follow-info text-center">
								{(this.props.data.facebook_url ||
									this.props.data.twitter_url ||
									this.props.data.linkedin) && (
									<>
										<div className="follow-us-title mb-1">Follow Us</div>
										{this.props.data.facebook_url && (
											<div className="social-icon mx-1">
												<a
													href={this.props.data.facebook_url}
													target="_blank"
													rel="noreferrer"
												>
													<i
														className="fab fa-facebook"
														width={30}
														height={30}
													/>
												</a>
											</div>
										)}
										{this.props.data.twitter_url && (
											<div className="social-icon mx-1">
												<a
													href={this.props.data.twitter_url}
													target="_blank"
													rel="noreferrer"
												>
													<i
														className="fab fa-twitter"
														width={30}
														height={30}
													/>
												</a>
											</div>
										)}
										{this.props.data.linkedin_url && (
											<div className="social-icon mx-1">
												<a
													href={this.props.data.linkedin_url}
													target="_blank"
													rel="noreferrer"
												>
													<i
														className="fab fa-linkedin"
														width={30}
														height={30}
													/>
												</a>
											</div>
										)}
									</>
								)}
							</div>
						</div>
					) : (
						<>
							<div className="d-flex flex-column align-items-center">
								<div className="d-flex community-image me-md-4">
									{this.props.data.community_image_url && (
										<img
											src={this.props.data.community_image_url}
											alt={this.props.data.community_name}
											width="170"
											height="170"
										/>
									)}
									{!this.props.data.community_image_url && (
										<i className="fas fa-users" width={170} height={170} />
									)}
								</div>
								<div className="follow-info text-center me-md-4 mt-2">
									{(this.props.data.facebook_url ||
										this.props.data.twitter_url ||
										this.props.data.linkedin) && (
										<>
											<div className="follow-us-title mb-1">Follow Us</div>
											{this.props.data.facebook_url && (
												<div className="social-icon mx-1">
													<a
														href={this.props.data.facebook_url}
														target="_blank"
														rel="noreferrer"
													>
														<i
															className="fab fa-facebook"
															width={30}
															height={30}
														/>
													</a>
												</div>
											)}
											{this.props.data.twitter_url && (
												<div className="social-icon mx-1">
													<a
														href={this.props.data.twitter_url}
														target="_blank"
														rel="noreferrer"
													>
														<i
															className="fab fa-twitter"
															width={30}
															height={30}
														/>
													</a>
												</div>
											)}
											{this.props.data.linkedin_url && (
												<div className="social-icon mx-1">
													<a
														href={this.props.data.linkedin_url}
														target="_blank"
														rel="noreferrer"
													>
														<i
															className="fab fa-linkedin"
															width={30}
															height={30}
														/>
													</a>
												</div>
											)}
										</>
									)}
								</div>
							</div>
							<div className="d-flex flex-grow-1 ms-md-3 flex-column justify-content-center">
								<div className="textual-info">
									<h1 className="community-name mb-4 text-center text-md-start">
										{this.props.data.community_name}
									</h1>
									<div
										className="community-description mb-4"
										dangerouslySetInnerHTML={{
											__html: DOMPurify.sanitize(
												this.props.data.community_description?.replace(
													/(?:\r\n|\r|\n)/g,
													""
												) || ""
											)
										}}
									/>
								</div>
							</div>
						</>
					)}
				</div>
				<style jsx>{`
					.community-details-container {
						border-radius: 8px;
						background: #f2f2f2;
					}

					.community-details-container .community-image {
						border-radius: 50%;
						overflow: hidden;
						border: 1px solid #d1d1d1;
						background: #fff;
						box-shadow: 3px 3px 25px 0px rgba(0, 0, 0, 0.13);
						width: 170px;
						height: 170px;
					}

					.community-details-container .community-image i {
						font-size: 100px;
					}

					.community-details-container .community-name {
						font-size: 28px;
						font-weight: 700;
					}

					.community-details-container .about-us-title {
						font-size: 15px;
						font-weight: 600;
					}

					.community-details-container .community-description {
						font-size: 14px;
						font-weight: 500;
					}

					.community-details-container .follow-us-title {
						font-size: 13px;
						font-weight: 500;
					}

					.community-details-container .follow-info .social-icon {
						display: inline-block;
						font-size: 20px;
					}

					.community-details-container .follow-info .social-icon a {
						text-decoration: none;
						color: #000;
					}

					p {
						margin-bottom: 0;
					}
				`}</style>
			</>
		);
	}
}

export default CommunityDetails;
